import { fetchQuery } from '@/services/messaging/fetchQuery';

export function getDeviceManagerEquipments(patientDetails) {
  if (patientDetails) {
    return fetchQuery("GetDeviceManagerEquipments", patientDetails);
  } else {
    return fetchQuery("GetDeviceManagerEquipments");
  }
}
